import { assignNamespace } from "../../common/namespace-utils";
import { o_util } from "../../common/namespaces";
import { defineStore } from "../nexus/defines.js";
import * as mappers from "./mappers.js";
import * as asyncMappers from "./asyncMappers.js";
import { fetchOnexData, transformAndAssignOnexData } from "./fragment.js";

export * from "./mappers.js";

assignNamespace(o_util, "onex", {
  isOnexGroup: mappers.isOnexVariant,
  mapOnexGroup: mappers.mapOnexVariant,
  isOnexVariant: mappers.isOnexVariant,
  mapOnexVariant: mappers.mapOnexVariant,
  withOnex: mappers.withOnex,
  customAssignments: mappers.customAssignments,
});

otto.onex.assignNamespace({
  assignments: defineStore(transformAndAssignOnexData()),
  getAssignments: asyncMappers.getAssignments,
  isOnexVariant: asyncMappers.isOnexVariant,
  mapOnexVariant: asyncMappers.mapOnexVariant,
});

/*                                                                  */
if (import.meta.env.MODE !== "test") fetchOnexData();
